module.exports = __webpack_public_path__ + "static/media/JOMO-Virtual-Appartmentv1.89af1618.png";